const tilesContainer = document.querySelector("[data-where-are-tiles]");

if (tilesContainer) {
  const tiles = tilesContainer.querySelectorAll("[data-where-are-tile]");

  tiles.forEach((tile) => {
    tile.addEventListener("click", function () {
      if (this.classList.contains("active")) {
        this.classList.remove("active");
      } else {
        tiles.forEach((t) => t.classList.remove("active"));
        this.classList.add("active");
      }
    });
  });
}
